<template>
    <div>
        <form method="post" id="payment-form" dusk="payment-form" v-on:submit.prevent>

            <div class="row">
                <div class="form-group col-md-6 col-12">
                    <label for="name">
                        {{$t('vue.checkout.stripeCreditCard.cardOwner')}}
                     </label>
                    <input class="form-control" id="name" name="name"
                           v-model="cardHolder"
                           placeholder="Jenny Rosen"
                           required>
                </div>
            </div>

            <div class="form-group">
                <label for="stripe-credit-card-container">
                    {{$t('vue.checkout.stripeCreditCard.creditCardDetails')}}
                </label>
                <div id="stripe-credit-card-container"></div>
                <div id="creditCardErrors" role="alert"
                     v-if="stripeErrors">
                    <span class="text-primary" v-html="stripeErrors"></span>
                </div>
            </div>

            <input type="hidden" dusk="creditCard" v-model="creditCardSource"
                   name="stripe_source">

            <div class="form-group text-right">
                <button class="btn btn-primary"
                        v-if="submitable"
                        v-on:click="formSubmit"
                        type="button"
                        dusk="submit-payment">
                    {{$t('general.continue')}}
                    <i class="fal fa-chevron-right"></i>
                </button>
                <button class="btn btn-primary disabled"
                        v-else
                        type="button"
                        dusk="submit-payment">
                    {{$t('general.continue')}}
                    <i class="fal fa-chevron-right"></i>
                </button>
            </div>

            <div id="mandate-acceptance">
                {{$t('vue.checkout.stripeCreditCard.message')}}
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "StripeCreditCardAdd",
        props: {
            setupIntentClientSecret: {
                type: String,
                required: true
            },
            publishableKey: {
                type: String,
                required: true
            },
            connectedAccountId: {
                type: String,
                required: true
            },
            stripeAccount: {
                type: String,
                required: true
            },
            givenCardHolder: {
                type: String,
                required: true
            },
            mandateText: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                stripe: {},
                stripeElements: {},
                stripeFormElement: {},
                stripeErrors: false,
                cardSource: "",
                creditCardSource: "",
                cardHolder: "",
                submitable: true
            };
        },
        methods: {
            initStripe() {
                const lang = document.documentElement.lang.split('-')[0]
                this.stripe = Stripe(this.publishableKey, {
                    stripeAccount: this.connectedAccountId,
                    locale: lang
                });
                this.stripeElements = this.stripe.elements();

                this.stripeFormElement = this.stripeElements.create('card');
                this.stripeFormElement.mount('#stripe-credit-card-container');

                const self = this;
                this.stripeFormElement.addEventListener('change', event => {
                    if (event.error) {
                        self.stripeErrors = event.errors.message;
                    } else {
                        self.stripeErrors = false;
                    }
                });
            },
            async formSubmit() {
                this.submitable = false;
                const {setupIntent, error} = await this.stripe.handleCardSetup(
                    this.setupIntentClientSecret,
                    this.stripeFormElement,
                    {
                        payment_method_data: {
                            billing_detail: {name: self.cardHolder}
                        }
                    }
                );
                if (error) {
                    this.stripeErrors = error.message;
                    this.submitable = true;
                } else {
                    this.$emit('credit-card-created', setupIntent);
                }
            },
        },
        mounted() {
            this.cardHolder = this.givenCardHolder;
            this.initStripe();
        }
    }
</script>

<style scoped>

</style>
